// extracted by mini-css-extract-plugin
export default {"label":"style_label__XDhZu"};